// extracted by mini-css-extract-plugin
module.exports = {"textarea-wrapper":"textarea-wrapper___n4XnP","textareaWrapper":"textarea-wrapper___n4XnP"};